module.exports = __webpack_public_path__ + "static/img/mac.acd98ae3.png";